export default __webpack_public_path__ + "static/media/Broker-Application-Form.60898163.pdf";